import { axiosInstance } from "../../base/store/axios";
import constants from "./constants";

export async function fetchContractProposal(id) {
  const data = await axiosInstance.get(`${constants.PROPOSAL_URL}${id}/`);

  return data;
}
